@if (isCustomizedApp && privacyUrl) {
  <a [href]="privacyUrl" target="_blank" rel="noopener" class="kgr-verticalMenu__item is-level-1">
    <span class="kgr-verticalMenu__itemIcon">
      <svg kgrIcon="security" [small]="true"></svg>
    </span>
    <span class="kgr-verticalMenu__itemLabel" i18n>Datenschutz</span>
  </a>
} @else {
  <button (click)="openPrivacyPdf()" type="button" class="kgr-verticalMenu__item is-level-1">
    <span class="kgr-verticalMenu__itemIcon">
      <svg kgrIcon="security" [small]="true"></svg>
    </span>
    <span class="kgr-verticalMenu__itemLabel" i18n>Datenschutz</span>
  </button>
}
